import React from 'react';
import { Link } from 'react-router-dom';
import classes from './HomeSlide.module.css';
import '../../fontawesome/css/all.css'
// import trump from '../../UI/img/trump.png';

const HomeSlide = (props) => {
    const image = require('../../UI/img/'+ props.pillImg +'.png');

    const rating = props.rating;
    var stars = [];
    for (let i = 0; i < rating; i++) {
        stars.push(
            <i className="fas fa-star " key={i}></i>);
    }
    for (let i = 0; i < 5 - rating; i++) {
        stars.push(
        <i className="far fa-star " key={i}></i>);
        }
    
   


    return (
                <div className={classes[props.color]}>
                <div className={classes.containers2}>
                    <div className={classes.gridcontainer}>
                    <div className={classes.gridItem}>
                        <div className={classes.itemTitle}>
                            <h1>{props.title}</h1>
                            <br/>
                            <p>
                                {props.subTitle}
                            </p>
                            <br/>
                                {stars}
                        </div>
                        <br/>
                        <div className={classes.itemDesc}>
                            
                        </div>
                    </div>
                    <div className={classes.gridItem}>
                        <img src={image.default}  className={classes.bigPill} />
                    </div>
                    <div className={classes.gridItem}>
                        <div className={classes.itemDesc}>
                            <h3>{props.priceBTC} BTC / {props.priceETH} ETH</h3>
                            <br/>
                            <p>{props.desc}
                                <br/><br />
                                Contains {props.content}mg of MDMA per pill.
                            </p>
                            <br/> <br/> <br/>
                            <Link to="/Shop">ORDER NOW</Link>
                        </div>
                    </div>
                </div>
            </div>
            </div>
    )
}

export default HomeSlide
